import React from 'react';

const Chemistry = () => {
  return (
    <div>
      Chemistry
      Chemistry
    </div>
  );
}

export default Chemistry;
